var FormatterHelper = /** @class */ (function () {
    function FormatterHelper() {
    }
    FormatterHelper.getformattedValue = function (value, culture, minimumFractionDigits, fallBackValue) {
        if (fallBackValue === void 0) { fallBackValue = 0; }
        if (typeof value == "string") {
            value = Number(value);
        }
        return value ?
            value.toLocaleString(culture, { minimumFractionDigits: minimumFractionDigits, maximumFractionDigits: minimumFractionDigits }) :
            (fallBackValue != null && fallBackValue !== undefined ?
                (fallBackValue).toLocaleString(culture, { minimumFractionDigits: minimumFractionDigits, maximumFractionDigits: minimumFractionDigits }) :
                null);
    };
    FormatterHelper.getCurrencyValue = function (value, culture, minimumFractionDigits, currencySymbol, fallBackValue) {
        if (fallBackValue === void 0) { fallBackValue = 0; }
        var valueFormatted = FormatterHelper.getformattedValue(value, culture, minimumFractionDigits, fallBackValue);
        if (valueFormatted == null || valueFormatted === undefined) {
            return "";
        }
        var valueWithCurrency = currencySymbol + valueFormatted;
        return valueWithCurrency;
    };
    return FormatterHelper;
}());
export { FormatterHelper };
